export default {
  title: {
    id: 'product_page_iphone17_title',
    defaultMessage: 'Samsung S26',
  },
  title2: {
    id: 'product_page_iphone17_title2',
    defaultMessage: 'But your next phone is',
  },
  breadcrumbProductTitle: {
    id: 'product_page_iphone17_breadcrumb_title',
    defaultMessage: 'Samsung S26',
  },
  metaTitle: {
    id: 'product_page_iphone17_meta_title',
    defaultMessage: 'Refurbished Samsung S26',
  },
  metaDescription: {
    id: 'product_page_iphone17_meta_description',
    defaultMessage: 'Template description',
  },
  addToCart: {
    id: 'product_page_iphone17_atc',
    defaultMessage: 'Check out our bundles',
  },
  addToCartLink: {
    id: 'product_page_iphone17_atc_link',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/iphone/e8724fea-197e-4815-85ce-21b8068020cc',
  },
  explanation: {
    id: 'product_page_iphone17_explanation',
    defaultMessage: 'Template',
  },
  explanation2: {
    id: 'product_page_iphone17_explanation2',
    defaultMessage: 'Template 2',
  },
  breadcrumbLabel: {
    id: 'product_page_iphone17_breadcrumb_label',
    defaultMessage: 'iPhone',
  },
  disclaimer: {
    id: 'product_page_iphone17_disclaimer',
    defaultMessage:
      '*Content is speculative only. Samsung S26 features are unconfirmed by Apple and are based on industry forecasts. BackMarket is not affiliated with Apple.',
  },
}
